
<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i> Utilisateurs
        </div>
        <div class="card-body">
          <button [disabled]="isLoading" class="btn btn-sm btn-primary" (click)="addUser()">Add User</button>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (user of users; track user.userId) {
                <tr>
                  <td>{{ user.userId }}</td>
                  <td>{{ user.email }}</td>
                  <td><button class="btn btn-sm btn-primary" type="button" (click)="editUser(user.userId)" tooltip="Details">Edit</button> | <button class="btn btn-sm btn-primary" type="button" (click)="editUserPassword(user.userId)" tooltip="Details">Edit password</button> | <button class="btn btn-sm btn-danger" type="button" (click)="deleteUser(user.userId)" tooltip="Details"><i class="fa fa-trash"></i></button></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add User Modal -->
<div bsModal #addUserModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Ajouter un utilisateur</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="add-user-email">Email</label>
          <input class="form-control" [(ngModel)]="newEmail" id="add-user-email" type="email">
        </div>
        <div class="form-group">
          <label for="add-user-password">Mot de passe</label>
          <input class="form-control" [(ngModel)]="newPassword" id="add-user-password" type="password">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="addUserModal.hide()">Annuler</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="saveAddUser()">
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          Valider
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit User Password Modal -->
<div bsModal #editUserPasswordModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Modifier le mot de passe</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="edit-user-password">Mot de passe</label>
          <input class="form-control" [(ngModel)]="editedPassword" id="edit-user-password" type="password">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="editUserPasswordModal.hide()">Annuler</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="saveEditUserPassword()">
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          Valider
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit User Modal -->
<div bsModal #editUserModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="editUserModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Modifier l'utilisateur</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="edit-user-email">Email</label>
          <input class="form-control" [(ngModel)]="editedEmail" id="edit-user-email" type="email">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="editUserModal.hide()">Annuler</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="saveEditUser()">
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          Valider
        </button>
      </div>
    </div>
  </div>
</div>